import { Dispatch, Middleware } from "redux";
import { LOCATION_CHANGE } from "connected-react-router";
import { MATCHING_ENGINE } from "../../accounts/Consts";
import { CleanUploadFilesState, resetMessageBanner } from "../reducers/DataIngestionReducer";
import IAppState from "../types/IAppState";

export const getNavigationSection = (pathname?: string): string => {
    if (!pathname || pathname === "/") {
        return "/";
    }

    const segments = pathname.split("/").filter(Boolean);

    if (segments.length >= 2) {
        return `/${segments[0]}/${segments[1]}`;
    }

    return `/${segments[0]}`;
};

export const clearSectionNotifications = (dispatch: Dispatch) => {
    dispatch(CleanUploadFilesState());
    dispatch(resetMessageBanner());
};

export const shouldClearSectionNotifications = (portalType: string, previousPath?: string, nextPath?: string): boolean => {
    if (portalType !== MATCHING_ENGINE || !previousPath || !nextPath) {
        return false;
    }

    return getNavigationSection(previousPath) !== getNavigationSection(nextPath);
};

export const clearSectionNotificationsMiddleware: Middleware = (store) => (next) => (action) => {
    if (action?.type !== LOCATION_CHANGE || action.payload?.isFirstRendering) {
        return next(action);
    }

    const state = store.getState() as IAppState;
    const previousPath = state.router?.location?.pathname as string | undefined;
    const nextPath = action.payload?.location?.pathname as string | undefined;

    const result = next(action);

    if (shouldClearSectionNotifications(state.account?.portalType, previousPath, nextPath)) {
        clearSectionNotifications(store.dispatch);
    }

    return result;
};
